import createT from 'T';
const T = createT();

T({
  // SessionBase
  'NetworkError when attempting to fetch resource.': 'Erreur réseau',
  'record not found': 'Login ou mot de passe incorrect',
  'Server Error': 'Il y a un problème sur le serveur',
  'Failed to fetch': 'Impossible de joindre le serveur',
  "'password' is mandatory": 'Il manque le mot de passe',
  "'email' is mandatory": "Il manque l'identifiant",
  email: 'Identifiant',
  password: 'Mot de passe',
  open: 'Connexion',
  close: 'Déconnexion',
});

export default T;
